/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_In_ProgressInputs */

const cs_enum_in_progress = /** @type {(inputs: Enum_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probíhá`)
};

const en_enum_in_progress = /** @type {(inputs: Enum_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Enum_In_ProgressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_in_progress = /** @type {((inputs?: Enum_In_ProgressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_In_ProgressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_in_progress(inputs)
	return cs_enum_in_progress(inputs)
});